// Menu entry for the Performance "HR" tab (KPI Planning + Appraisal for every
// employee, not just the logged-in user's direct reports). Must match
// isHrKpiMenu in the PerformanceKpiManagement Lambda, which checks it before
// returning the organisation-wide lists.
export const HR_KPI_MENU_KEY = "hrkpiperformance";

export const isHrKpiMenu = (item) => item?.key === HR_KPI_MENU_KEY;
